<template>
  <div v-if="data.show" class="cardPartner">
    <div class="container">
      <div class="close" @click="data.close">
        <i class="fa fa-times" title="FECHAR" />
      </div>
      <div class="card column jutify-center">
        <div class="title row align-center">
          <label>ID {{ data.id_doutor }}</label> &nbsp; {{ data.nome }}
        </div>
        <div v-if="data.loader" class="row justify-center">
          <Loader layout="mini" />
        </div>
        <div class="content row column-s wrap" v-else>
          <div class="section grid-12">CADASTRO ({{ data.status_cadastro }})</div>

          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>PJ</label>{{ data.status_pj }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>PF</label>{{ data.status_pf }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Sócio</label>{{ data.status_doutor_socio }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Selfie Documento</label>{{ data.status_documentos_selfie_doc }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Apto:</label> {{ data.apto ? "apto" : "não apto" }}
          </div>
          <div class="section grid-12">PENDÊNCIAS</div>
          <div class="column">
            {{ data.pendencias }}
          </div>
          <div class="section grid-12">ATUAÇÃO</div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Atendimentos:</label> {{ data.atendimentos }}
          </div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Atendimentos últimos 30 dias:</label> {{ data.atd_ult_30_dias }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Pagamentos:</label> {{ data.pagamentos | money }}
          </div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Pagamentos últimos 30 dias:</label> {{ data.pg_ult_30_dias | money }}
          </div>

          <div class="section grid-12">ENGAJAMENTO</div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Último acesso:</label> {{ data.dh_ultimo_acesso | date }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Disponível:</label> {{ data.disponibilidade ? "Sim" : "Não" }}
          </div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Disponível última vez:</label>
            {{ data.dh_atualizacao_disponibilidade | date }}
          </div>

          <div class="section grid-12">INFORMAÇÕES</div>
          <div class="grid-5 grid-6-m grid-12-s column">
            <label>Razão Social:</label> {{ data.razao_social }}
          </div>
          <div class="grid-4-g grid-6-m grid-12-s column">
            <label>E-mail:</label> {{ data.email }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Celular:</label> {{ data.celular | phone }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Fone:</label> {{ data.fone | phone }}
          </div>

          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Cidade:</label> {{ data.cidade }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Técnicos:</label> {{ data.tecnicos }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Distância:</label> {{ data.distancia }}.0 km
          </div>
        </div>
        <div class="clients">
          <div class="title" @click="showClientForm = !showClientForm">
            <Button :layout="showClientForm ? 'red-go' : 'green-go'" title="NOVO CLIENTE">{{ showClientForm ? "x" : "+"
              }}</Button>
            Clientes Associados
          </div>
          <div v-if="showClientForm" class="row justify-center">
            <div class="grid-6 grid-11-s">
              <Search :data="clientSearch" />
            </div>
          </div>

          <div class="list row wrap-s" v-if="data.clientes.length && data.clientes[0] !== null">
            <div class="client grid-5-s" v-for="(client, i) of data.clientes" :key="'cli' + data.id_doutor + i"
              @click="data.removeClient(client)">
              {{ client.cliente }}
              <i class="fa fa-trash font-20" title="EXCLUIR" />
            </div>
          </div>
          <!-- <div class="detail" v-if="detail.show">
            <div v-if="detail.loader" class="row justify-center">
              <Loader layout="small" />
            </div>
            <div class="content" v-else>
              <div class="title">
                <label>(ID {{ detail.id }})</label> {{ detail.nome }}
                <div class="status column">
                  Situação
                  <b v-if="detail.status == 'ativo'" class="text-green"
                    >{{ detail.status }}
                  </b>
                  <b v-if="detail.status == 'inativo'" class="text-red"
                    >{{ detail.status }}
                  </b>
                  <b
                    v-if="detail.status != 'inativo' && detail.status != 'ativo'"
                    class="text-orange"
                    >{{ detail.status }}
                  </b>
                </div>
              </div>
              <div class="row wrap column-s">
                <div class="grid-4 column"><label>E-mail</label>{{ detail.email }}</div>
                <div class="grid-3 column">
                  <label>Fone: </label>{{ detail.fone | phone }}
                </div>
                <div class="grid-2 column">
                  <label>Frequência: </label>{{ detail.frequencia }}
                </div>
                <div class="grid-2 column">
                  <label>Pessoa</label>{{ detail.tipo_faturamento }}
                </div>

                <div class="grid-7 tipo_cliente column">
                  <label>Endereço</label
                  >{{
                    detail.logradouro +
                    ", " +
                    detail.numero +
                    " - " +
                    detail.cidade +
                    "/" +
                    detail.estado
                  }}
                </div>

                <div class="grid-2 column">
                  <label>Tipo faturamento</label>{{ detail.tipo_faturamento }}
                </div>
                <div class="grid-2 tipo_cliente column">
                  <label>Tipo Cliente</label>{{ detail.tipo_cliente }}
                </div>
              </div>
            </div>

            <Button
              class="grid-12"
              layout="red-go"
              :loader="detail.loader"
              @click="data.removeClient(detail.id)"
              >REMOVER CLIENTE</Button
            >
          </div> -->
        </div>
        <Button layout="red-go" @click="data.remove" :loader="data.loader">REMOVER DOS PARCEIROS</Button>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Search from "@/components/Search.vue";
import Loader from "@/components/Loader.vue";
import { mapActions } from "vuex";
export default {
  name: "CardPartner",
  props: {
    data: Object,
  },
  components: { Button, Search, Loader },
  data() {
    return {
      showClientForm: false,
      detail: {},

      clientSearch: {
        search: null,
        loader: false,
        placeholder: "Nome do cliente",
        action: () => {
          this.clientSearch.loader = true;
          this.LOAD_CLIENTS({ nome: this.clientSearch.search })
            .then(({ data }) => {
              this.clientSearch = {
                ...this.clientSearch,
                loader: false,
                autocomplete: {
                  name: "nome_cliente",
                  list: data,
                  choice: (item) => {
                    confirm(
                      `Adicionar o Cliente ${item.nome} ao Parceiro ${this.data.nome}?`
                    );
                    {
                      this.clientSearch.autocomplete.list = [];
                      this.showClientForm = false;
                      this.data.action(item.id);
                    }
                  },
                },
              };
            })
            .catch(() => {
              this.clientSearch.loader = false;
            });
        },
      },
    };
  },
  methods: {
    ...mapActions("admin", ["LOAD_CLIENTS", "CLIENT_GET"]),
    detailClient(client) {
      this.detail = { loader: true, show: true, id: client.id_cliente };
      this.CLIENT_GET(client.id_cliente).then(
        ({ data }) => (this.detail = { ...this.detail, loader: false, ...data })
      );
    },
  },
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.cardPartner
  label
    @include label
  .container
    position: absolute
    width: 80%
    margin-left: -5%
    z-index: 888
    top: 100px
    @media (min-width: $small)
      left: 50%
      margin-left: -32%
      width: 60%
    .card
      @include card
      width: 98%
      line-height: 35px
      .title
        font-size: 23px
        font-weight: bold
        margin-bottom: 20px

      button
        margin-top: 30px
      .content
        height: 350px
        overflow-y: auto
        padding-bottom: 60px
        .section
          color: $orange-1
          font-weight: bold
          margin-top: 17px
          font-size: 17px
          height: 14px
        label
          margin-bottom: -8px
        .column
          margin: 17px 3px
          @media (max-width: $small)
            margin: 9px 0
            text-align: center
        .status
          margin-top: 23px
    .clients
      margin-top: 7px
      .title
        text-align: center
        color: $supporter-1
        font-size: 15px
        cursor: pointer
        padding: 12px
      .list
        margin: 30px
        .client
          padding: 12px
          border-radius: 19px
          border: 2px solid #333
          margin: 0 9px
          @media (max-width: $small)
            padding: 12px

          &:hover
            cursor: pointer
            color: $red
            border: 2px solid $red

      .detail
        margin-top: 12px
        .content
          .title
            font-size: 24px
            &:hover
              text-decoration: none
              cursor: none
            .status
              font-size: 14px
              color: $font-color
              b
               font-size: 21px
               text-transform: uppercase

    .close
        @include close
  .mask
    @include mask
    z-index: 613
</style>
